/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import ContentCards from '../../../../../../../ResourcesRevised/Components/Resuable/ContentCard';
import { ContentTypeKey } from '../../../../../../../ResourcesRevised/types';
// Import the needed functions and types from content_graphql_api
import contentGraphQLApi from '../../../../../../../actions/resource_graphql_actions/content_graphql_api';
import { ContentType as GraphQLContentType } from '../../../../../../../actions/resource_graphql_actions/content_graphql_types';
import ContentListContainer from './ContentListContainer';
import { useParams } from 'react-router-dom';
import useResourceHelper from './useResourceHelper';

// Extract the getContent and searchContent functions from the imported API
const { getContent, searchContent } = contentGraphQLApi;

interface DocumentsCardsListProps {
	selectedItems: string[];
	handleCheckboxChange: (itemId: string, checked: boolean) => void;
	handleBulkSelectionUpdate: (ids: string[], add: boolean) => void;
	onCountUpdate: (count: number) => void;
	selectAll: boolean;
	showPath?: boolean;
	StatusVisible?: boolean;
	ContentView?: string;
	itemsPerView: number;
	viewAll: boolean;
	handleViewAll?: (isViewAll: ContentTypeKey) => void;
	searchValue?: string;
}

const DocumentsCardsList: React.FC<DocumentsCardsListProps> = ({
	selectedItems,
	handleCheckboxChange,
	handleBulkSelectionUpdate,
	onCountUpdate,
	selectAll,
	showPath = false,
	StatusVisible = true,
	ContentView = 'grid',
	itemsPerView,
	viewAll,
	handleViewAll,
	searchValue
}) =>
{
	const { companyId: networkCompanyId } = useParams();
	const sessionCompanyId = useSelector((state: any) => state?.mysession?.session?.companyId);
	const companyId = networkCompanyId || sessionCompanyId;
	const { isAdminView } = useResourceHelper();

	// Fetch documents with pagination
	const fetchDocuments = async (filter: any) =>
	{
		try
		{
			let response;

			filter.from = isAdminView ? 'Configuration' as const : 'MyResource' as const;
			if (searchValue && searchValue.trim() !== '')
			{
				filter.contentType = GraphQLContentType.DOCUMENT;
				response = await searchContent(companyId, searchValue.trim(), filter);
			}
			else
			{
				filter.filters.types = [ GraphQLContentType.DOCUMENT ];
				filter.filters.nested = true;
				response = await getContent(companyId, filter);
			}

			if (response && response.data)
			{
				return response;
			}
		}
		catch (error)
		{
			console.error('Error fetching documents:', error);
		}
	};

	return (
		<ContentListContainer
			selectedItems={selectedItems}
			handleCheckboxChange={handleCheckboxChange}
			getContentApi={fetchDocuments}
			handleBulkSelectionUpdate={handleBulkSelectionUpdate}
			onCountUpdate={onCountUpdate}
			selectAll={selectAll}
			viewAll={viewAll}
			handleViewAll={handleViewAll}
			searchValue={searchValue}
			type='Documents'
		>
			<ContentCards
				section='documents'
				type='Documents'
			/>
		</ContentListContainer>
	);
};

// Add display name
DocumentsCardsList.displayName = 'DocumentsCardsList';

export default DocumentsCardsList;